import { render, staticRenderFns } from "./InventoryDischargeModalComponent.vue?vue&type=template&id=20cf3e2c"
import script from "./InventoryDischargeModalComponent.vue?vue&type=script&lang=js"
export * from "./InventoryDischargeModalComponent.vue?vue&type=script&lang=js"
import style0 from "./InventoryDischargeModalComponent.vue?vue&type=style&index=0&id=20cf3e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports